import { render, staticRenderFns } from "./ChioseDialog.vue?vue&type=template&id=538f5712&scoped=true&"
import script from "./ChioseDialog.vue?vue&type=script&lang=js&"
export * from "./ChioseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChioseDialog.vue?vue&type=style&index=0&id=538f5712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f5712",
  null
  
)

export default component.exports